
import { defineComponent } from "vue";
import FilminLogo from "@/components/FilminLogo.vue";

export default defineComponent({
  components: {
    FilminLogo,
  },
});
